import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sprout } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background">
        <div className="h-12 w-12 rounded-2xl bg-emerald-700 flex items-center justify-center animate-pulse">
          <Sprout className="h-6 w-6 text-white" />
        </div>
        <p className="text-sm text-muted-foreground">Growing your garden…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
